import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/directory/${number | ':directoryId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/directory/:directoryId`;

export const URL = (workOrderId: number, directoryId: number): RouteDefinition => `${baseRoute}/${workOrderId}/directory/${directoryId}`;
